import React, { useState, useRef, useEffect } from "react";
import {
  FaPaperPlane,
  FaSearch,
  FaMapMarkerAlt,
} from "react-icons/fa";
import ProfileSidebar from "../component/ProfileSidebar";
import axios from "axios";
import { getStoredToken } from "../component/utils/getStoredToken";
import { io } from "socket.io-client";
import { baseurl, imgurl } from "../baseurl";
import MobileChatHeader from "../component/MobileChatHeader";
import ChatMobile from "./ChatMobile";
import NavigateHome from "../component/utils/NavigateHome";
import PageCount from "../component/utils/PageCount";
const API_BASE = "https://chat.soulsathi.com";

const Chats = () => {
  const token = getStoredToken();
  const [chatUsers, setChatUsers] = useState([]); // from /chat/list
  const [activeChat, setActiveChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState("");

  
  const socketRef = useRef();
  const messagesEndRef = useRef(null);

  // Format time (10:20 AM)
  const formatTime = (dateStr) =>
    new Date(dateStr).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

  // --- Scroll to bottom
  const scrollToBottom = () => {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  // --- SOCKET.IO
  useEffect(() => {
    if (!token) return;

    socketRef.current = io(API_BASE);
    socketRef.current.emit("join", { token });

    socketRef.current.on("new_message", (msg) => {
      if (activeChat && msg.sender_id === activeChat.user_id) {
        setMessages((prev) => [...prev, msg]);
        scrollToBottom();
      }
      loadChatList();
    });

    return () => socketRef.current.disconnect();
  }, [activeChat]);

  // --- Load chat list
const loadChatList = async () => {
  try {
    const res = await axios.post(
      `${API_BASE}/chat/list`,
      {}, // <-- EMPTY BODY
      {
        headers: {
          Authorization: `Bearer ${token}`,   // <-- TOKEN IN HEADER
        },
      }
    );

    setChatUsers(res.data);

    // if (!activeChat && res.data.length > 0) {
    //   setActiveChat(res.data[0]);
    // }
  } catch (err) {
    console.error("Failed to load chat list:", err);
  }
};


  // --- Load chat history
  const loadMessages = async (uid) => {
    try {
      const res = await axios.post(`${API_BASE}/chat/history`, {
        token,
        uid,
      });
      setMessages(res.data);
      scrollToBottom();

      // Mark read
      await axios.post(`${API_BASE}/chat/read`, { token, uid });
    } catch (err) {
      console.error("Failed to load messages:", err);
    }
  };

  // --- When active chat changes
  useEffect(() => {
    if (activeChat) {
      loadMessages(activeChat.uid);
    }
  }, [activeChat]);

  // --- Initial load
  useEffect(() => {
    loadChatList();
  }, []);

  // --- Send message
  const sendMessage = async () => {
    if (!newMsg.trim()) return;

    const text = newMsg;
    setNewMsg("");

    try {
      await axios.post(`${API_BASE}/chat/send`, {
        token,
        uid: activeChat.uid,
        message: text,
      });

      loadMessages(activeChat.uid);
      loadChatList();
    } catch (err) {
      console.error("Failed to send:", err);
    }
  };

  return (

    <>

 <NavigateHome/>
    <div className="view-profile-page d-none d-lg-block">
<PageCount pageName = {"Desktop Chat Page"}/>
      <ProfileSidebar />

     <div className="modern-chat-container position-relative padding-chat">
  {/* LEFT CHAT SIDEBAR */}
  <div className="chat-sidebar">
    <div className="sidebar-header">
      <h5 className="fw-bold">Chats</h5>
      <div className="search-box">
        <FaSearch />
        <input type="text" placeholder="Search..." />
      </div>
    </div>

    <div className="chat-list">
      {chatUsers.map((u) => (
        <div
          key={u.user_id}
          className={`chat-list-item ${
            activeChat?.user_id === u.user_id ? "active" : ""
          }`}
          onClick={() => setActiveChat(u)}
        >
          <img src={imgurl + u.profile_photo} alt={u.display_id} />
          <div>
            <h6>{u.display_id}</h6>
            <small>{u.message || "Start chatting..."}</small>
          </div>

          {/* Unread dot */}
          {!u.read_status && u.sender_id !== u.user_id && (
            <span className="unread-dot"></span>
          )}
        </div>
      ))}
    </div>
  </div>

  {/* RIGHT CHAT WINDOW - show only if activeChat exists */}
  {activeChat && (
    <div className="chat-main">
      {/* Top profile */}
      <div className="chat-profile-header">
        <div className="d-flex align-items-center">
          <img
            src={imgurl + activeChat.profile_photo}
            alt={activeChat.display_id}
          />
          <div className="ms-2">
            <h5 className="fw-bold mb-0">{activeChat.display_id}</h5>
          </div>
        </div>
      </div>

      {/* MESSAGE LIST */}
      <div className="chat-body">
        {messages.map((msg, i) => (
          <div
            key={i}
            className={`message ${
              msg.is_me ? "sent" : msg.sender_id === activeChat.user_id ? "received" : "sent"
            }`}
          >
            <p>{msg.message}</p>
            <span>{formatTime(msg.created_at)}</span>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* MESSAGE INPUT */}
      <div className="chat-input-box">
        <input
          type="text"
          className="form-control chat-input"
          placeholder="Type a message..."
          value={newMsg}
          onChange={(e) => setNewMsg(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button className="btn send-btn" onClick={sendMessage}>
          <FaPaperPlane />
        </button>
      </div>
    </div>
  )}
</div>

    </div>


    <ChatMobile/>

    </>
  );
};

export default Chats;
